import COMMON_TOPIC_HEADERS from './commonTopicHeaders'
import TABLE_HEADERS from './tableHeaders'

export default Object.freeze({
  SORT_ORDER: 1,
  URI: '?type=paidSickLeave',
  JSON_VALUE: 'paidSickLeave',
  PRETTY_PRINT: 'Paid Sick Leave',
  TOPICS: {
    ...COMMON_TOPIC_HEADERS,
    JURISDICTION_NAME: {
      HEADER: 'Name',
      ACCESSOR: 'jurisdictionName'
    },
    EFFECTIVE_DATE: {
      HEADER: 'Effective Date',
      ACCESSOR: 'Effective Date'
    },
    ACCRUAL_RATE: {
      HEADER: 'Accrual Rate',
      ACCESSOR: 'accrualRate'
    },
    DATE_ACCRUAL_BEGINS: {
      HEADER: 'Date Accrual Begins',
      ACCESSOR: 'dateAccrualBegins'
    },
    MAX_USE_PER_YEAR: {
      HEADER: 'Max Use per Year',
      ACCESSOR: 'maxUsePerYear'
    },
    CARRYOVER: {
      HEADER: 'Carryover',
      ACCESSOR: 'carryover'
    }
  },
  get CSV_HEADER_ROW_VALUES() {
    return [
      TABLE_HEADERS.JURISDICTION_NAME.HEADER,
      TABLE_HEADERS.JURISDICTION_TYPE.HEADER,
      TABLE_HEADERS.PAID_LEAVE_TYPE.HEADER,
      this.TOPICS.EFFECTIVE_DATE.HEADER,
      this.TOPICS.ACCRUAL_RATE.HEADER,
      this.TOPICS.DATE_ACCRUAL_BEGINS.HEADER,
      this.TOPICS.MAX_USE_PER_YEAR.HEADER,
      this.TOPICS.CARRYOVER.HEADER
    ]
  }
})
